import { useRouter } from "next/router";
import PropTypes from "prop-types";
import type { FC, ReactNode } from "react";
import { useEffect, useState } from "react";
import { useAuth } from "../../hooks/use-auth";

interface AuthGuardProps {
  children: ReactNode;
  role?: "admin";
}

export const AuthGuard: FC<AuthGuardProps> = (props) => {
  const { children, role } = props;
  const auth = useAuth();
  const router = useRouter();
  const [checked, setChecked] = useState(false);

  useEffect(
    () => {
      const returnUrl = router.query.returnUrl;

      if (returnUrl) {
        router.push(returnUrl as string);
      }
      if (!router.isReady) {
        return;
      }

      if (!auth.isAuthenticated) {
        router.push({
          pathname: "/authentication/login",
          query: { returnUrl: router.asPath },
        });
      }
      setChecked(true);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [router.isReady]
  );

  if (!checked) {
    return null;
  }

  if (role && role !== auth?.user?.role) {
    return null;
  }

  // If got here, it means that the redirect did not occur, and that tells us that the user is
  // authenticated / authorized.

  return <>{children}</>;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};
